import { TDynamicObject } from './types';

export function getCookie(param: string) {
  const cookies = document.cookie.split('; ');
  const result = cookies.reduce((prev, curr) => {
    const [key, value] = curr.split('=');
    return {
      ...prev,
      [key]: value,
    };
  }, {}) as TDynamicObject;

  return result[param] ? result[param] : null;
}

export function getCookieGol(param: string) {
  const cookies = document.cookie.split('; ');
  const result = cookies.reduce((prev, curr) => {
    const [key, value] = curr.split('=');
    return {
      ...prev,
      [key]: value,
    };
  }, {}) as TDynamicObject;

  return result[param] ? JSON.parse(result[param]).user_id : null;
}

export function getApplicationCookie() {
  return getCookie('__caxpto');
}

export function getApplicationCookieGol() {
  return getCookieGol('user_properties');
}
